import { WORK_OS_IRIS_COLOR_NAME, DEV_PRIMARY_COLOR, MARKETER_PRIMARY_COLOR } from "styles/color-consts";

export default {
  title: "New monday homepage",
  paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
  topic: { text: "" },
  date: "11 Jan 2023",
  tags: [
    { tagText: "Product", tagColor: WORK_OS_IRIS_COLOR_NAME },
    { tagText: "Teams", tagColor: DEV_PRIMARY_COLOR },
    { tagText: "Plan type", tagColor: MARKETER_PRIMARY_COLOR }
  ],
  rightSectionPaddingTop: "8px",
  asset: {
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/whats_new_example_3.png"
    }
  },
  paddingTop: "32px"
};
